import React from "react";
import { Collapse } from "reactstrap";
import { NavLink, Link } from "react-router-dom";

// icons
import IconMdFlightTakeoff from "react-icons/lib/md/flight-takeoff";
import IataIcon from "react-icons/lib/md/timeline";
import Tsc from "react-icons/lib/ti/clipboard";
import ReportsIcon from "react-icons/lib/md/insert-chart";
import ProformaIcon from "react-icons/lib/md/bubble-chart";
import InvoiceIcon from "react-icons/lib/md/receipt";
import IconSearch from "react-icons/lib/md/search";
import IconPDM from "react-icons/lib/md/extension";
import IconDown from "react-icons/lib/md/chevron-right";
import IconManifest from "react-icons/lib/md/layers";
import PaymentIcon from "react-icons/lib/md/credit-card";
import IconDashboard from "react-icons/lib/md/dashboard";
import PdmReport from "react-icons/lib/fa/edit";
import InputIcon from "react-icons/lib/md/input";
import PdmDataEntry from "react-icons/lib/fa/cloud-upload";
import IataValidationIcon from "react-icons/lib/md/perm-data-setting";
import PaymentReconciliation from "react-icons/lib/fa/wpforms";
import HelpIcon from "react-icons/lib/md/help-outline";
import TicketSearch from "react-icons/lib/md/question-answer";
import FlightOperationIcon from "react-icons/lib/md/flight"
import PassengerIcon from "react-icons/lib/md/date-range"

const BSPMenuComponent = ({
  handleClick,
  selected,
  handleOpen,
  handleDataEntry,
}) => {
  return (
    <ul className="list-unstyled mt-3 nav-list clearfix">
      <li
        onClick={handleClick.bind(this, 0)}
        className={selected === 0 ? "selected" : ""}
      >
        <Link to="/">
          <IconDashboard size="18" />
          <span className="name">DashBoard</span>
        </Link>
      </li>
      <li
        onClick={handleClick.bind(this, 30)}
        className={selected === 30 ? "selected" : ""}
      >
        <Link to="#">
          <IconManifest size="18" />
          <span className="name">Manifest</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 30} onClick={handleOpen.bind(this, 30)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="#" onClick={handleDataEntry}>
                <InputIcon size="18" />
                <span className="name">Data Entry</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/search" activeClassName="active">
                <IconSearch size="18" />
                <span className="name">
                  Manifest
                  <br /> Report
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/ticket-search" activeClassName="active">
                <TicketSearch size="18" />
                <span className="name">
                  Search By
                  <br /> Ticket
                </span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>

      <li
        onClick={handleClick.bind(this, 4)}
        className={selected === 4 ? "selected" : ""}
      >
        <NavLink to="/flight" activeClassName="active">
          <IconMdFlightTakeoff size="18" className="icon-flight-takeoff" />
          <span className="name">Flight</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 5)}
        className={selected === 5 ? "selected" : ""}
      >
        <NavLink to="/iata" activeClassName="active">
          <IataIcon size="18" className="icon-flight-takeoff" />
          <span className="name">Iata Report</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 6)}
        className={selected === 6 ? "selected" : ""}
      >
        <NavLink to="/invoice" activeClassName="active">
          <InvoiceIcon size="18" />
          <span className="name">
            Invoice
            <br /> Reconciliation
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 7)}
        className={selected === 7 ? "selected" : ""}
      >
        <NavLink to="/tsc" activeClassName="active">
          <Tsc size="18" className="icon-clipboard" />
          <span className="name">TSC Statement</span>
        </NavLink>
      </li>
      {/*<li onClick={handleClick.bind(this, 33)} className={(selected === 33) ? 'selected': ''}>*/}
      {/*<NavLink to="/final-destination-report" activeClassName="active">*/}
      {/*<FinalDestinationReportsIcon size="18"className="icon-insert-chart"/>*/}
      {/*<span className="name">Final Destination <br/> Report</span>*/}
      {/*</NavLink>*/}
      {/*</li>*/}
      <li
        onClick={handleClick.bind(this, 9)}
        className={selected === 9 ? "selected" : ""}
      >
        <NavLink to="/proforma" activeClassName="active">
          <ProformaIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Proforma
            <br /> Report
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 31)}
        className={selected === 31 ? "selected" : ""}
      >
        <NavLink to="/security-charge-report" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Security Charge
            <br /> Report
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 13)}
        className={selected === 13 ? "selected" : ""}
      >
        <Link to="#">
          <PaymentIcon size="18" />
          <span className="name">Payment</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 13} onClick={handleOpen.bind(this, 13)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="/unmatched-payments" activeClassName="active">
                <ReportsIcon size="18" className="icon-insert-chart" />
                <span className="name">
                  Unmatched
                  <br /> Payments
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/payment-reconciliation" activeClassName="active">
                <PaymentReconciliation size="18" className="icon-Wpforms" />
                <span className="name">
                  Payment
                  <br /> Reconciliation
                </span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>
      <li
        onClick={handleClick.bind(this, 50)}
        className={selected === 50 ? "selected" : ""}
      >
        <Link to="#">
          <IconPDM size="18" />
          <span className="name">PDM</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 50} onClick={handleOpen.bind(this, 50)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="/pdm-report" activeClassName="active">
                <PdmReport size="18" className="FaEdit" />
                <span className="name">Report</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/pdm-data-entry" activeClassName="active">
                <PdmDataEntry size="18" className="icon-FaCloudUpload" />
                <span className="name">Data Entry</span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>
      <li
        onClick={handleClick.bind(this, 107)}
        className={selected === 107 ? "selected" : ""}
      >
        <NavLink to="/iata-validation" activeClassName="active">
          <IataValidationIcon size="18" className="icon-insert-chart" />
          <span className="name">IATA Validation</span>
        </NavLink>
      </li>

      <li
        onClick={handleClick.bind(this, 177)}
        className={selected === 177 ? "selected" : ""}
      >
        <NavLink to="/unmatched-domestic-payment" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Unmatched <br /> Domestic <br /> Payment
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 60)}
        className={selected === 60 ? "selected" : ""}
      >
        <NavLink to="/billed-per-airport" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Billed per <br /> Airport
          </span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/flight-operations" activeClassName="active">
          <FlightOperationIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Flight <br /> Operations
          </span>
        </NavLink>
      </li>
      <li
      >
        <NavLink to="/passenger-level-data" activeClassName="active">
          <PassengerIcon size="18" className="icon-insert-chart" />
          <span className="name">
           Passenger level <br /> Data
          </span>
        </NavLink>
      </li>
      {/* <li onClick={handleClick.bind(this, 108)} className={(selected === 108) ? 'selected': ''}>
                <NavLink to="/maker-checker" activeClassName="active">
                    <MakerCheckerIcon size="18" className="icon-insert-chart"/>
                    <span className="name">Maker <br/> Checker</span>
                </NavLink>
            </li> */}
      <hr></hr>

      <li
        onClick={handleClick.bind(this, 68)}
        className={selected === 68 ? "selected" : ""}
      >
        <NavLink to="/help-center" activeClassName="active">
          <HelpIcon size="18" className="icon-insert-chart" />
          <span className="name">Help Center</span>
        </NavLink>
      </li>
    </ul>
  );
};

export default BSPMenuComponent;



// WEBPACK FOOTER //
// ./src/shared/components/nav/menu/bsp.js